import React, { useState } from "react";
import { TextField, PrimaryButton, Stack, MessageBar, MessageBarType } from "@fluentui/react";
import axios from "axios";

const CreateMemberForm = (props) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const handleInputChange = (event, newValue) => {
    const { name } = event.target;
    setFormData((prev) => ({ ...prev, [name]: newValue }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage(null);
    setSuccessMessage(null);

    if (formData.password !== formData.confirmPassword) {
      setErrorMessage("Passwords do not match.");
      return;
    }

    try {
      const response = await axios.post("/api/create-user", {
        name: formData.name,
        email: formData.email,
        password: formData.password,
      });

      console.log(response);

      setSuccessMessage(response.data.message || "Account created successfully!");
      setFormData({ name: "", email: "", password: "", confirmPassword: "" });
    } catch (error) {
      setErrorMessage(error.response?.data?.error || "An error occurred while creating the account.");
    }
  };

  return (
    <Stack
      tokens={{ childrenGap: 15, padding: 20 }}
      styles={{ root: { maxWidth: 400, margin: "auto" } }}
    >
      <h2>Create New Account</h2>
      {errorMessage && (
        <MessageBar messageBarType={MessageBarType.error} isMultiline={false}>
          {errorMessage}
        </MessageBar>
      )}
      {successMessage && (
        <MessageBar messageBarType={MessageBarType.success} isMultiline={false}>
          {successMessage}
        </MessageBar>
      )}

      <TextField
        label="Name"
        name="name"
        value={formData.name}
        onChange={handleInputChange}
        required
      />
      <TextField
        label="Email"
        name="email"
        type="email"
        value={formData.email}
        onChange={handleInputChange}
        required
      />
      <TextField
        label="Password"
        name="password"
        type="password"
        value={formData.password}
        onChange={handleInputChange}
        required
      />
      <TextField
        label="Confirm Password"
        name="confirmPassword"
        type="password"
        value={formData.confirmPassword}
        onChange={handleInputChange}
        required
      />
      <PrimaryButton text="Create Account" onClick={handleSubmit} />
      {props.children}
    </Stack>
  );
};

export default CreateMemberForm;